import { sanitizeCreation } from "./sanitize";
import type { Creation } from "./types";

export interface LibraryEntry {
  creation: Creation;
  icon: string | null;
}

const PNG_DATA_URL = /^data:image\/png;base64,[A-Za-z0-9+/=]+$/;
const MAX_ICON_LENGTH = 8_000;

export function sanitizeEntries(raw: unknown): LibraryEntry[] {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((item) => {
    try {
      const { creation, icon } = item as { creation: unknown; icon: unknown };
      const safeIcon = typeof icon === "string" && icon.length <= MAX_ICON_LENGTH && PNG_DATA_URL.test(icon) ? icon : null;
      return [{ creation: sanitizeCreation(creation), icon: safeIcon }];
    } catch {
      return [];
    }
  });
}
